var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"basic":true}},[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Starred Topics")]),_vm._v(" "),_c('span',{attrs:{"slot":"breadcrumbs"},slot:"breadcrumbs"},[_c('b-breadcrumb',{attrs:{"items":_vm.breadcrumbs}})],1),_vm._v(" "),_c('topics-table',{attrs:{"view":_vm.view}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d6d660d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/client/starred-topics/index.vue
// module id = null
// module chunks = 